export default (text: string | null | undefined) => {
    // Convert to lowercase and first letter to uppercase
    if (!text) return ""
    return text.charAt(0).toUpperCase() + text.slice(1)
}
